

















import { Component, Vue, Prop } from "vue-property-decorator";
import { authenticationStore } from "../api/authentication/authentication.module";
// import { UserModel } from '../modules/authentication/auth.model';
// import { Logout } from '../modules/authentication/auth.api';

@Component
export default class Topbar extends Vue {
  @Prop() private user!: any;
  // private isLoading: boolean = false;

  // private logout() {
  //   this.isLoading = true;
  //   localStorage.clear();
  //   setTimeout(() => {
  //     this.$router.push('/login');
  //     this.isLoading = false;
  //   }, 3000);
  // }

  private logout() {
    this.isLoading = true;
    setTimeout(() => {
      authenticationStore.LOGOUT();
      this.$router.push("/login");
      this.isLoading = false;
    }, 3000);
  }
  // private async logout() {
  //   this.isLoading = true;
  //   await Logout().then((response) => {
  //     localStorage.removeItem("token");
  //     this.isLoading = false;
  //     this.$router.push("/login");
  //   }).catch((error) => {
  //     this.$toast.error(error.message);
  //     this.isLoading = false;
  //   })
  // }
}
